/** rates group: rates, tiers, sharing, quotations (rate:view_cost is grant-only below owner) (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const ratesPermissions = [
  'rate:read',
  'rate:manage',
  'rate:approve',
  'rate:view_cost',
  'rate:share',
  'quote:manage',
] as const;

export type RatesPermission = (typeof ratesPermissions)[number];
